import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

import Merch1 from "../../assets/images/Photo/Merch/merch1.png";
import Merch2 from "../../assets/images/Photo/Merch/merch2.png";
import Merch3 from "../../assets/images/Photo/Merch/merch3.png";
import Merch4 from "../../assets/images/Photo/Merch/merch4.png";
import Merch5 from "../../assets/images/Photo/Merch/merch5.png";
import Merch6 from "../../assets/images/Photo/Merch/merch6.png";
import Merch7 from "../../assets/images/Photo/Merch/merch7.webp";

export default function MerchCarousel({className}) {
  const containerRef = useRef(null);

  useEffect(() => {
    // Seleccionar todos los elementos con la clase bouncybouncy rounded-lg
    const bouncyElements = containerRef.current.querySelectorAll('.bouncybouncy');
    
    // Aplicar animación a cada elemento
    bouncyElements.forEach((element, index) => {
      gsap.to(element, {
        y: -40, // Movimiento hacia arriba de 15px
        duration: 2 + (index * 0.2), // Duración variada para cada elemento
        ease: "sine.inOut",
        repeat: -1, // Repetir infinitamente
        yoyo: true, // Regresa al estado original
        delay: index * 0.3 // Delay escalonado para cada elemento
      });
    });

    // Cleanup function para limpiar las animaciones
    return () => {
      bouncyElements.forEach(element => {
        gsap.killTweensOf(element);
      });
    };
  }, []);

  return (
    <div ref={containerRef} className="w-full h-full flex justify-center items-center space-x-12 overflow-x-hidden">
      
          <img src={Merch6} alt='Bluekali' className='w-48 object-cover bouncybouncy rounded-lg'/>
        
        
          <img src={Merch2} alt='Bluekali' className='h-40 object-cover bouncybouncy rounded-lg'/>
        
        
          <img src={Merch4} alt='Bluekali' className='w-24 object-cover bouncybouncy rounded-lg'/>
        
        
          <img src={Merch3} alt='Bluekali' className='w-36 object-cover bouncybouncy rounded-lg'/>
        
        
          <img src={Merch7} alt='Bluekali' className='w-40 object-cover bouncybouncy rounded-lg'/>
        
        
          <img src={Merch1} alt='Bluekali' className='w-24 object-cover bouncybouncy rounded-lg'/>
        
        
          <img src={Merch5} alt='Bluekali' className='w-52 object-cover bouncybouncy rounded-lg'/>
        
    </div>
  );
};